import { Component } from '@angular/core';

@Component({
  selector: 'app-property-division-success-pf',
  templateUrl: './property-division-success-pf.component.html',
  styleUrls: ['./property-division-success-pf.component.scss'],
})
export class PropertyDivisionSuccessPfComponent {
  constructor() {}
}
